/* eslint-disable react-hooks/exhaustive-deps */
import FormLabelWarning from "components/FormLabel/FormLabelWarning"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { dataEditorDefault } from "pages/project-component-detail/types"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { STATUS_RESPONSE } from "types"
import {
  deleteProjectBuildCreateAdditionalInfoMiddleware,
  postProjectBuildCreateAdditionalInfoMiddleware,
} from "../api.services"
import FormInputEditorCard from "../molecules/FormInputEditorCard"
import ShowInfoAdditionalCard from "../molecules/ShowInfoAdditionalCard"
import { useAdditionalAndExtraInfoProjectBuild } from "../project-build.hook"
import { ProjectBuildAdditionalDetail } from "../project-build.type"
import { useUploadFileWorkerController } from "workers/uploadFileWorkerController"
import { configureStore } from "stores/configureStore"
import { closeLoading, startLoading } from "reducers/loading"
import { isUndefined } from "lodash"
import { useBoolean, useWindowSize } from "helpers/hooks"
interface Props {
  additionals: ProjectBuildAdditionalDetail[]
  idProjectBuild: string
  isDeleteComment: boolean
  isEditorInput: boolean
  isLabel: boolean
  updateWhenCreateAdditional: () => void
  updateWhenDeleteAdditional: (idAdditional: string) => void
  isDeleted?: boolean
  conversationId?: string
  subNameDownload: string
  styleListAdditional?: React.CSSProperties
  styleRoot?: React.CSSProperties
  collapseComponent?: boolean
}
const AdditionalInfoCard = (props: Props) => {
  const {
    additionals,
    idProjectBuild,
    isDeleteComment,
    isEditorInput,
    isLabel,
    updateWhenCreateAdditional,
    updateWhenDeleteAdditional,
    isDeleted,
    conversationId,
    subNameDownload,
    styleListAdditional,
    styleRoot,
    collapseComponent,
  } = props
  const {
    dataEditor,
    isLoading,
    isScroll,
    keyInputFile,
    ref,
    listFileAdd,
    setDataEditor,
    fileSelectedHandler,
    handleChangeEditor,
    handleDeleteFileNoDownload,
    setListFileAdd,
    handleChangeScroll,
    clearStorageWhenSubmit,
  } = useAdditionalAndExtraInfoProjectBuild("additional_info", idProjectBuild)
  const { isMobile } = useWindowSize()
  const { workerUploadFile } = useUploadFileWorkerController()
  const [scrollDirection, setScrollDirection] = useState<"top" | "bottom">(
    "bottom"
  )
  const showIconScroll = useBoolean(false)

  useEffect(() => {
    setTimeout(() => {
      handleChangeScroll()
    }, 200)
  }, [JSON.stringify(additionals)])

  const handleScroll = () => {
    if (!ref.current || isUndefined(styleRoot)) return
    const { scrollTop, scrollHeight, clientHeight } = ref.current
    const lengthScroll = isMobile ? 100 : 300

    if (scrollHeight - clientHeight > lengthScroll) {
      showIconScroll.setValue(true)
    } else {
      showIconScroll.setValue(false)
    }
    if (scrollTop === 0) {
      setScrollDirection("bottom")
    } else if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setScrollDirection("top")
    }
  }
  useEffect(() => {
    if (collapseComponent) {
      setTimeout(() => {
        handleScroll()
      }, 500)
    }
  }, [collapseComponent])

  useEffect(() => {
    const el = ref.current
    if (el) el.addEventListener("scroll", handleScroll)
    return () => {
      if (el) el.removeEventListener("scroll", handleScroll)
    }
  }, [])

  const onSubmitButton = (dataEditor: string) => {
    if (!idProjectBuild || !workerUploadFile) {
      toast(
        <LabelNotificationPage
          messenger="The workerUploadFile is not working!"
          type="error"
        />
      )
      return
    }
    configureStore.dispatch(startLoading())
    isLoading.setValue(true)
    // const htmlPuri = parseDraftToHtml(dataEditor)
    let newDataEditor = dataEditor
    listFileAdd
      .filter((item) => item.type === "inline")
      .forEach((item) => {
        newDataEditor = newDataEditor.replace(item.url || "", item.id)
      })
    postProjectBuildCreateAdditionalInfoMiddleware(
      workerUploadFile,
      idProjectBuild,
      {
        description: newDataEditor,
        files: listFileAdd.map((file) => {
          return {
            file: file.file,
            file_name: file.name,
            key: file.id,
            type: file.type,
            file_type: file.file_type,
          }
        }),
      },
      (type: STATUS_RESPONSE, messenger: string) => {
        isLoading.setValue(false)
        if (type === STATUS_RESPONSE.SUCCESS) {
          updateWhenCreateAdditional()
          setListFileAdd([])
          setDataEditor("")
          isScroll.setValue(true)
          clearStorageWhenSubmit()
        } else {
          closeLoading()
          toast(<LabelNotificationPage messenger={messenger} type={type} />)
        }
      }
    )
  }
  const onDeleteComment = (oldItem: ProjectBuildAdditionalDetail) => {
    if (!oldItem.id) {
      return
    }
    isLoading.setValue(true)
    deleteProjectBuildCreateAdditionalInfoMiddleware(
      oldItem.id,
      (type: STATUS_RESPONSE, messenger: string) => {
        toast(<LabelNotificationPage messenger={messenger} type={type} />)
        isLoading.setValue(false)
        if (type === STATUS_RESPONSE.SUCCESS) {
          updateWhenDeleteAdditional(oldItem.id)
        }
      }
    )
  }
  const onDisableButtonSubmit = () => {
    if (dataEditor !== dataEditorDefault || listFileAdd.length) {
      return false
    }
    return true
  }

  const handleClickScroll = () => {
    if (!ref.current) return

    if (scrollDirection === "bottom") {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: "smooth",
      })
    } else {
      ref.current.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  const renderButtonScroll = () => {
    return (
      <button
        className="scroll-btn"
        onClick={handleClickScroll}
        style={{
          bottom: 20,
        }}
      >
        {scrollDirection === "top" ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18.0702 9.57L12.0002 3.5L5.93018 9.57"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 20.4999V3.66992"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18.0702 14.4302L12.0002 20.5002L5.93018 14.4302"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 3.5V20.33"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        )}
      </button>
    )
  }

  return (
    <div
      className="build-info-form flex flex-col justify-between h-full overflow-hidden"
      ref={isUndefined(styleRoot) ? undefined : ref}
      style={{
        ...styleRoot,
      }}
    >
      {isLabel ? (
        <FormLabelWarning
          className="mb-3 mr-6 "
          label="This information would be shared with invitees."
          minHeight={38}
        />
      ) : null}
      <div
        className="flex flex-1 flex-col"
        ref={isUndefined(styleListAdditional) ? undefined : ref}
        style={{
          ...styleListAdditional,
        }}
      >
        {additionals.length
          ? additionals.map((additional, index) => (
              <div className="pr-0 md:pr-6 mb-3 last:mb-0" key={index}>
                <ShowInfoAdditionalCard
                  isView={isDeleteComment}
                  item={additional}
                  onDeleteComment={onDeleteComment}
                  conversationId={conversationId}
                  idProjectBuild={idProjectBuild}
                  // styleRootCard={{
                  //   marginBottom: index === additionals.length - 1 ? 0 : 12,
                  // }}
                  isDeleted={isDeleted}
                  subNameDownload={subNameDownload}
                />
              </div>
            ))
          : null}
        {!additionals.length && isEditorInput ? (
          <div className="flex items-center w-full h-full justify-center">
            <p className="font-semibold text-14 leading-24 color-gray-7a">
              There is no additional information
            </p>
          </div>
        ) : null}
      </div>

      {!isDeleted && !isEditorInput && (
        <div className="conversation-editor">
          <FormInputEditorCard
            handleChangeEditor={handleChangeEditor}
            dataEditor={dataEditor}
            fileSelectedHandler={fileSelectedHandler}
            listFileAdd={listFileAdd}
            keyInputFile={keyInputFile.value}
            handleDeleteFileNoDownload={handleDeleteFileNoDownload}
            onSubmitButton={onSubmitButton}
            onDisableButtonSubmit={onDisableButtonSubmit()}
            styleRoot={{
              height: "auto",
            }}
          />
        </div>
      )}
      {showIconScroll.value ? renderButtonScroll() : null}
    </div>
  )
}
export default AdditionalInfoCard
